// TODO: These method should be remove to only use LS as repository (DAOs).
export function setItemLocalStorage(key: string, item: any) {
  localStorage.setItem(key, JSON.stringify(item));
}

export function getItemLocalStorage(key: string): any {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console?.error(
      '@clientos-commons-northbound-api - getItemLocalStorage error: ',
      err?.message ?? err
    );
    return undefined;
  }
}

export function removeItemLocalStorage(key: string): any {
  try {
    return localStorage.removeItem(key);
  } catch (err) {
    console?.error(err);
    return undefined;
  }
}
